<div class="wrapper"></div>
<div class="container">
  @for (item of items; track $index) {
    <button
      mat-raised-button
      class="navigation-item"
      [ngClass]="{ 'is-active': item.isActive }"
      (click)="handleChangeSelection(item.id)"
    >
      <mat-icon
        [@navigationItem]="item.isActive ? 'active' : 'inactive'"
        [svgIcon]="item.isActive ? item.icons.active : item.icons.default"
      ></mat-icon>
      <small [@navigationItem]="item.isActive ? 'active' : 'inactive'">{{
        item.title
      }}</small>
    </button>
  }
</div>
<app-mobile-bottom-navigation-floating-menu
  [isVisible]="isMenuActive"
  (onClose)="handleChangeSelection(navigationItemIdEnum.MENU)"
></app-mobile-bottom-navigation-floating-menu>
<app-mobile-bottom-navigation-floating-profile
  [isVisible]="isProfileActive"
  (onClose)="handleChangeSelection(navigationItemIdEnum.PROFILE)"
></app-mobile-bottom-navigation-floating-profile>
